import { render } from "./NotificationView.vue?vue&type=template&id=9ad3ad56&scoped=true&ts=true"
import script from "./NotificationView.vue?vue&type=script&lang=ts"
export * from "./NotificationView.vue?vue&type=script&lang=ts"

import "./NotificationView.vue?vue&type=style&index=0&id=9ad3ad56&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ad3ad56"]])

export default __exports__